import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SessionModel } from '../../models/SessionModel';
import * as EquipmentStore from '../../store/Equipment';
import { ApplicationState } from '../../store';
import { EquipmentModel } from '../../models/EquipmentModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';

type MyProps =
    { EqpList: EquipmentStore.EquipmentList } & { SessionState: SessionModel } & typeof EquipmentStore.actionCreators;


const EquipmentComponent: React.FunctionComponent<MyProps> = (props: MyProps) => {

    interface locationProps {
        calledFrom: string,
        source1: string,
        source2: string,
        showButton: boolean
    }
  
    const location = useLocation();
       
    const [screenTitle, updateTitle] = useState<string>("");
    const [showButtons, updateShowButtons] = useState<boolean>(false);

    useEffect(() => {
        
        if (location.state != undefined) {
            const locProp: locationProps = location.state;
            updateShowButtons(locProp.showButton);            
            switch (locProp.calledFrom) {
                case "CON":
                    updateTitle(`Equipment Covered Under Contract ${locProp.source1}`);
                    props.loadEquipmentsForContract(locProp.source1);
                    break;
                default:
                    break;
            }
            
        } else {
            updateShowButtons(true);
            updateTitle(props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName);
            props.loadEquipments(props.SessionState);            
        }                                

    }, []);
          
    return (        
        <Container fluid={true}>
            <LoadingIcon loading={props.EqpList.loading} title={screenTitle} address={props.SessionState.SelectedSM.address} />
            <Col>
                {props.EqpList.items.map((item, index) =>
                    <Row key={index}>
                        <EquipmentCard item={item} companyCode={props.SessionState.SelectedAR.companyCode} showButtons={showButtons} ></EquipmentCard>
                    </Row>
                )}
            </Col>
        </Container>
    );
}

class EquipmentCard extends React.PureComponent<{ item: EquipmentModel, companyCode: string, showButtons: boolean }> {

 
    public render() {
                                
        return (<Card className='equipment-card'>
            <CardHeader>
                <Row>
                    <Col><SaLabel Text={"Manufacturer"} /> 
                        {this.props.item.manufacturer} 
                    </Col>
                    <Col className="right-align">
                        <SaLabel Text={"Model"} /> 
                        {this.props.item.modelNum}  
                    </Col>
                </Row>
            </CardHeader> 
            <CardBody>
                <Row>
                    <Col>
                        <SaLabel Text={"Serial #"} /> {this.props.item.serialNum}
                    </Col>
                    <Col className="right-align">
                        <SaLabel Text={"Location"} /> {this.props.item.location}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SaLabel Text={"Description"} /> {this.props.item.description}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SaLabel Text={"Last Repair Date"} /> {this.props.item.lastRepairDate}
                        </Col>
                        <Col className="right-align">
                        <SaLabel Text={"Age (years)"} /> {this.props.item.eqpAge!=0&&this.props.item.eqpAge}
                        </Col>
                </Row>
            </CardBody>
            <CardFooter style={{ display: this.props.showButtons ? 'block' : 'none' }}>                
                <Row>                                        
                    <Col className="center-align">
                        <Link to={{ pathname: '/history', state: { EqpLog: this.props.item.logNum } }} ><Button size="sm">History</Button></Link> 
                    </Col>
                </Row>
                </CardFooter>
        </Card>);
    }
}

export default connect(
    (state: ApplicationState) => ({ ...{ EqpList: state.equipmentState }, ...{ SessionState: state.sessionState }}),
    EquipmentStore.actionCreators)(EquipmentComponent as any);